var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingapore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_1791)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_1791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2934 3H3V13.0067H37.2934V3Z",
    fill: "#D91D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2934 13H3V23H37.2934V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2947 7.99664C13.2947 10.073 11.6135 11.7609 9.53045 11.7609C7.4541 11.7609 5.76622 10.073 5.76622 7.99664C5.76622 5.92029 7.4474 4.23241 9.53045 4.23241C11.6068 4.23911 13.2947 5.92029 13.2947 7.99664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4735 7.99665C14.4735 9.95915 12.8794 11.5533 10.9169 11.5533C8.95446 11.5533 7.36035 9.95915 7.36035 7.99665C7.36035 6.03416 8.95446 4.44006 10.9169 4.44006C12.8794 4.44006 14.4735 6.03416 14.4735 7.99665Z",
    fill: "#D91D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99262 8.09042L9.48357 7.69524L8.97453 8.09042L9.16877 7.45411L8.65973 7.06563L9.28933 7.07233L9.48357 6.43603L9.67781 7.07233L10.3141 7.06563L9.79838 7.45411L9.99262 8.09042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0047 8.09042L13.4956 7.69524L12.9799 8.09042L13.1808 7.45411L12.6651 7.06563L13.3014 7.07233L13.4956 6.43603L13.6899 7.07233L14.3195 7.06563L13.8104 7.45411L14.0047 8.09042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.002 6.60349L11.493 6.20831L10.9772 6.60349L11.1782 5.96719L10.6624 5.57871H11.2987L11.493 4.9491L11.6872 5.57871H12.3168L11.8078 5.96719L12.002 6.60349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7495 10.4682L10.2338 10.0797L9.72471 10.4682L9.91895 9.83858L9.40991 9.4501H10.0395L10.2338 8.82049L10.428 9.4501H11.0643L10.5486 9.83858L10.7495 10.4682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2545 10.4682L12.7455 10.0797L12.2364 10.4682L12.4307 9.83858L11.9149 9.4501H12.5513L12.7455 8.82049L12.9397 9.4501H13.5693L13.0603 9.83858L13.2545 10.4682Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_1791",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_1791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_1791",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/Singapore.e635c71d439396a13c2bdab0caad71aa.svg";
export { ForwardRef as ReactComponent };